// MODULES
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// COMPONENTS
import { RouteNeuralNetworkComponent } from './Templates/RouteNeuralNetwork/route-neural-network.component';
import { MultipleChoiceComponent } from './Templates/MultipleChoice/multiple-choice.component';
import { NeuralNetworkComponent } from './Templates/NeuralNetwork/neural-network.component';
import { PrettyTooltipComponent } from './Templates/PrettyTooltip/pretty-tooltip.component';
import { ProgressCardComponent } from './Templates/ProgressCard/progress-card.component';
import { ProgressBarComponent } from './Templates/ProgressBar/progress-bar.component';
import { DatatableComponent } from './Templates/Datatable/datatable.component';
import { Select2Component } from './Templates/Select2/select2.component';
import { TableComponent } from './Templates/Table/table.component';

// PIPES
import { GetIndexFromMultipleArrayPipe } from 'src/app/pipes/get-index-from-multiple-array.pipe';
import { GetDatatableHidingFieldsPipe } from '../pipes/get-datatable-hiding-fields.pipe';
import { GetAbsolutePercentagePipe } from 'src/app/pipes/get-absolute-percentage.pipe';
import { CheckElementPropertyPipe } from 'src/app/pipes/check-element-property.pipe';
import { LocalStringToNumberPipe } from 'src/app/pipes/local-string-to-number.pipe';
import { GetObjectPropertiesPipe } from 'src/app/pipes/get-object-properties.pipe';
import { GetBooleanResultPipe } from 'src/app/pipes/get-boolean-result.pipe';
import { ArrayUnstructuredPipe } from '../pipes/array-unstructured.pipe';
import { ArrayMultisortPipe } from 'src/app/pipes/array-multisort.pipe';
import { ColorConverterPipe } from 'src/app/pipes/color-converter.pipe';
import { ArrayTransposePipe } from 'src/app/pipes/array-transpose.pipe';
import { SecondsToTimePipe } from 'src/app/pipes/seconds-to-time.pipe';
import { GetMenuParentPipe } from 'src/app/pipes/get-menu-parent.pipe';
import { GetPercentagePipe } from 'src/app/pipes/get-percentage.pipe';
import { SetPercentagePipe } from 'src/app/pipes/set-percentage.pipe';
import { NormalizeTextPipe } from 'src/app/pipes/normalize-text.pipe';
import { UncommentHtmlPipe } from 'src/app/pipes/uncomment-html.pipe';
import { SetAlertTypePipe } from 'src/app/pipes/set-alert-type.pipe';
import { DateToMonthsPipe } from 'src/app/pipes/date-to-months.pipe';
import { MonthsToDatePipe } from 'src/app/pipes/months-to-date.pipe';
import { SanitizeHtmlPipe } from 'src/app/pipes/sanitize-html.pipe';
import { SanitizeUrlPipe } from 'src/app/pipes/sanitize-url.pipe';
import { LimitNumberPipe } from 'src/app/pipes/limit-number.pipe';
import { ArrayFilterPipe } from 'src/app/pipes/array-filter.pipe';
import { ArraySlicePipe } from 'src/app/pipes/array-slice.pipe';
import { GetParentsPipe } from 'src/app/pipes/get-parents.pipe';
import { CastValuePipe } from 'src/app/pipes/cast-value.pipe';
import { ArrayMapPipe } from 'src/app/pipes/array-map.pipe';
import { SetValuePipe } from 'src/app/pipes/set-value.pipe';
import { SetFillPipe } from 'src/app/pipes/set-fill.pipe';
import { KeysPipe } from 'src/app/pipes/keys.pipe';
import { NamePipe } from 'src/app/pipes/name.pipe';


@NgModule({
  declarations: [
    GetIndexFromMultipleArrayPipe,
    GetDatatableHidingFieldsPipe,
    RouteNeuralNetworkComponent,
    GetAbsolutePercentagePipe,
    CheckElementPropertyPipe,
    LocalStringToNumberPipe,
    GetObjectPropertiesPipe,
    MultipleChoiceComponent,
    PrettyTooltipComponent,
    NeuralNetworkComponent,
    ProgressCardComponent,
    ArrayUnstructuredPipe,
    ProgressBarComponent,
    GetBooleanResultPipe,
    ArrayMultisortPipe,
    ColorConverterPipe,
    DatatableComponent,
    ArrayTransposePipe,
    GetPercentagePipe,
    SecondsToTimePipe,
    SetPercentagePipe,
    NormalizeTextPipe,
    UncommentHtmlPipe,
    GetMenuParentPipe,
    MonthsToDatePipe,
    DateToMonthsPipe,
    SanitizeHtmlPipe,
    Select2Component,
    SetAlertTypePipe,
    SanitizeUrlPipe,
    ArrayFilterPipe,
    LimitNumberPipe,
    ArraySlicePipe,
    TableComponent,
    GetParentsPipe,
    CastValuePipe,
    ArrayMapPipe,
    SetValuePipe,
    SetFillPipe,
    KeysPipe,
    NamePipe,
  ],
  imports: [
    ReactiveFormsModule,
    NgApexchartsModule,
    CommonModule,
    FormsModule,
  ],
  exports: [
    GetIndexFromMultipleArrayPipe,
    GetDatatableHidingFieldsPipe,
    RouteNeuralNetworkComponent,
    GetAbsolutePercentagePipe,
    CheckElementPropertyPipe,
    LocalStringToNumberPipe,
    GetObjectPropertiesPipe,
    MultipleChoiceComponent,
    PrettyTooltipComponent,
    NeuralNetworkComponent,
    ProgressCardComponent,
    ArrayUnstructuredPipe,
    ProgressBarComponent,
    GetBooleanResultPipe,
    ReactiveFormsModule,
    ArrayMultisortPipe,
    NgApexchartsModule,
    ColorConverterPipe,
    DatatableComponent,
    ArrayTransposePipe,
    GetMenuParentPipe,
    NormalizeTextPipe,
    SecondsToTimePipe,
    SetPercentagePipe,
    GetPercentagePipe,
    UncommentHtmlPipe,
    SanitizeHtmlPipe,
    SetAlertTypePipe,
    Select2Component,
    MonthsToDatePipe,
    DateToMonthsPipe,
    SanitizeUrlPipe,
    ArrayFilterPipe,
    LimitNumberPipe,
    ArraySlicePipe,
    TableComponent,
    GetParentsPipe,
    CastValuePipe,
    ArrayMapPipe,
    SetValuePipe,
    SetFillPipe,
    FormsModule,
    KeysPipe,
    NamePipe,
  ], providers: [ColorConverterPipe, SetValuePipe]
})
export class SharedModuleModule { }
